import { AntiForgery, Path } from './config.js';

export function getPresentationQuiz(presentationId) {
    return fetch(`${Path.WebAppsApi}/PresentationQuiz/GetQuizPlayerDisplay`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            [AntiForgery.Header]: AntiForgery.Token,
            'X-Requested-With': 'XMLHttpRequest'
        },
        mode: 'cors',
        body: JSON.stringify({
            Id: presentationId,
            PresentationId: presentationId,
            AuthTicketId: window.SiteData.AuthTicket,
            MediasiteChannelId: window.SiteData.CollectionId
        })
    }).then(result => result.json()).then(jsonData => {
        if (jsonData.RedirectUrl) {
            location.href = jsonData.RedirectUrl;
            return new Promise();
        }
        else {
            return jsonData;
        }
    });
}

/**
 * 
 * @param {Object} quizResultParams
 * @param {string} quizResultParams.PresentationId
 * @param {string} quizResultParams.PresentationQuizId
 * @param {string} quizResultParams.AuthTicketId
 * @param {string} quizResultParams.MediasiteChannelId
 * @param {string} quizResultParams.QuizResultContextId
 * 
 */
export function getQuizResults(quizResultParams) {
    return fetch(`${Path.WebAppsApi}/QuizResult/FindOrCreateResult`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            [AntiForgery.Header]: AntiForgery.Token
        },
        mode: 'cors',
        body: JSON.stringify(quizResultParams)
    }).then(result => result.json()).then(result => result.Entity);
}

/**
 * 
 * @param {Object} answerDetails
 * @param {string} answerDetails.PresentationQuizId
 * @param {string} answerDetails.PresentationId
 * @param {string} answerDetails.CatalogId
 * @param {string} answerDetails.QuizResultId
 * @param {string} answerDetails.SubQuizId
 * @param {string} answerDetails.QuestionId
 * @param {string} answerDetails.SubmittedAnswer
 * @param {string} answerDetails.QuizResultContextId
 */
export function setQuizAnswer(answerDetails) {

    return fetch(`${Path.WebAppsApi}/QuizResult/SetAnswer`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            [AntiForgery.Header]: AntiForgery.Token
        },
        mode: 'cors',
        body: JSON.stringify(answerDetails)
    }).then(result => result.json());
}

/**
 * 
 * @param {Object} scoreQuizParams
 * @param {string} scoreQuizParams.PresentationId
 * @param {string} scoreQuizParams.PresentationQuizId
 * @param {string} scoreQuizParams.AuthTicketId
 * @param {string} scoreQuizParams.MediasiteChannelId
 * @param {string} scoreQuizParams.QuizResultContextId
 * 
 */
export function scoreQuiz(scoreQuizParams) {
    return fetch(`${Path.WebAppsApi}/QuizResult/ScoreQuiz`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            [AntiForgery.Header]: AntiForgery.Token
        },
        mode: 'cors',
        body: JSON.stringify(scoreQuizParams)
    }).then(result => result.json()).then(result => result.Entity);
}


export function scoreSubQuiz(presentationId, presentationQuizId, subQuizId) {
    return fetch(`${Path.WebAppsApi}/QuizResult/ScoreSubQuiz`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            [AntiForgery.Header]: AntiForgery.Token
        },
        mode: 'cors',
        body: JSON.stringify({
            PresentationQuizId: presentationQuizId,
            PresentationId: presentationId,
            SubQuizId: subQuizId,
            AuthTicketId: window.SiteData.AuthTicket,
            MediasiteChannelId: window.SiteData.CollectionId
        })
    }).then(result => result.json()).then(result => result.Entity);
}

/**
 * 
 * @param {string} presentationId
 * @param {string} presentationQuizId
 * @param {string} channelId
 */
export function resetQuizAnswers(presentationId, presentationQuizId) {

    const data = {
        PresentationQuizId: presentationQuizId,
        PresentationId: presentationId,
        AuthTicketId: window.SiteData.AuthTicket,
        MediasiteChannelId: window.SiteData.CollectionId
    }

    return fetch(`${Path.WebAppsApi}/QuizResult/ResetAnswers`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            [AntiForgery.Header]: AntiForgery.Token
        },
        mode: 'cors',
        body: JSON.stringify(data)
    }).then(result => result.json());
}
